import { EffectDef, makeGain } from './types';

/** Dynamics compressor (DynamicsCompressorNode). */
export const compressor: EffectDef = {
  type: 'compressor',
  name: 'Compressor',
  params: [
    { key: 'threshold', label: 'Thresh', min: -60, max: 0, default: -18, step: 1, unit: 'dB' },
    { key: 'ratio', label: 'Ratio', min: 1, max: 20, default: 4, step: 0.5, unit: ':1' },
    { key: 'attack', label: 'Attack', min: 0.001, max: 0.5, default: 0.01, step: 0.001, unit: 's' },
    { key: 'release', label: 'Release', min: 0.01, max: 1, default: 0.2, step: 0.01, unit: 's' },
    { key: 'knee', label: 'Knee', min: 0, max: 40, default: 10, step: 1, unit: 'dB' },
  ],
  build(ctx, p) {
    const input = makeGain(ctx, 1);
    const output = makeGain(ctx, 1);
    const comp = ctx.createDynamicsCompressor();
    input.connect(comp);
    comp.connect(output);

    const apply = (params: Record<string, number>) => {
      comp.threshold.value = params.threshold;
      comp.ratio.value = params.ratio;
      comp.attack.value = params.attack;
      comp.release.value = params.release;
      comp.knee.value = params.knee;
    };
    apply(p);

    return {
      input,
      output,
      update: apply,
      dispose: () => {
        comp.disconnect();
        input.disconnect();
        output.disconnect();
      },
    };
  },
};